export default __webpack_public_path__ + "static/salvador-flag-677bd023e2d9cbcfc166d90c5320e45d.svg";